import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-heart-line text-2xl text-primary-400"></i>
                </div>
                <span className="text-xl font-heading font-bold text-background-50 tracking-wide whitespace-nowrap">
                  {t('site.name')}
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed max-w-xs">
                {t('site.description')}
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link
                    to="/"
                    className="text-sm text-background-400 hover:text-background-200 transition-colors"
                  >
                    {t('nav.home')}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-400 hover:text-background-200 transition-colors"
                  >
                    {t('nav.about')}
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">法律信息</h4>
              <ul className="space-y-2.5">
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-background-200 transition-colors">
                    {t('footer.privacy')}
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-background-200 transition-colors">
                    {t('footer.terms')}
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">{t('footer.copyright')}</p>
            <p className="text-xs text-background-600">{t('footer.disclaimer')}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}